import {useEffect} from 'react';
import {useApplicationStore} from '@/app/model/applicationStore';

const EVENTS = [
    'pointerdown',
    'keydown',
    'touchstart',
    'wheel',
    'scroll',
] as const;

export const useGlobalUserActivity = () => {
    const handleUserInteraction = useApplicationStore(
        (state) => state.actions.handleUserInteraction,
    );

    useEffect(() => {
        let activated = false;

        const cleanup = () => {
            clearTimeout(timer);

            EVENTS.forEach((event) => {
                document.removeEventListener(event, activate);
            });
        };

        const activate = () => {
            if (activated) return;

            activated = true;
            cleanup();
            handleUserInteraction();
        };

        const timer = window.setTimeout(activate, 300);

        EVENTS.forEach((event) => {
            document.addEventListener(event, activate, {passive: true});
        });

        return cleanup;
    }, [handleUserInteraction]);
}
